module.exports = __webpack_public_path__ + "static/img/解决方案-煤矿反三违-开箱即用算法库.b8ca0b9b.png";